import React, { useEffect, useState } from 'react';
import './TerminAcc.css';
import Calendar from '../Calendar/Calendar';
import '../Home/Home.css';
import axios from 'axios';
import { DatePicker, Skeleton } from 'antd';
import moment from 'moment';
import { environment } from '../../environment';
import { useParams } from 'react-router-dom';
import swal from 'sweetalert';
import ColumnGroup from 'antd/es/table/ColumnGroup';
import { Alert } from '@mui/material';

let token = localStorage.getItem("token") ? localStorage.getItem("token") : null;

let data = token ?  JSON.parse(atob(token.split('.')[1])) : {}
const isAdmin = data.data?.role === 'admin';
let user = data?.data;

const TerminAcc = () => {
    const id = data.data._id;
    const email = data.data.email;
    const phone = "076224065"; 
    const clientName = data.data?.username;

    var [allDates, setAllDates] = useState([]);
    const [occupiedHours, setOccupiedHours] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [time, setTime] = useState('');
    
    const minutes = [0, 30];
    let hours = [...Array(24)].map((_, i) => 5 + i).filter(h => h <= 17);

    
    useEffect(() => {
      const getOccupiedHours = async () => {
        try {
          const response = await axios.get(`${environment.LOCALHOST_URL}/termin/hours`);
          setOccupiedHours(response.data.availableHours);
          console.log(response.data)
          setAllDates(response.data.dateHours)
            console.log(response.data.dateHours)
          } catch (error) {
            console.error(error);
          }
        };
        getOccupiedHours();
      }, []);
      
      allDates.forEach((d) => {
        occupiedHours.forEach((h) => {
          if (new Date(d.date).toDateString() === selectedDate.toDateString()) {
            hours = hours.filter((hour) => hour !== h.hour)
          }
        })
      })
      
      
      const handleChanges = e => {
      setTime(e.target.value);
      console.log(e.target.value)
    };

    const handleReservation = async () => {

    const registerTerminAcc = `${environment.LOCALHOST_URL}/termin/registeracc/${id}/${email}/${phone}/${clientName}`;

    const formattedDate = moment(selectedDate).format('DD-MM-YYYY');
    await axios(registerTerminAcc, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        client: id,
        clientTel: phone,
        clientEmail: email,
        terminHour: time,
        terminDate: formattedDate
      }),
    })
    .then(() => {
      swal({
            title: `Termini u dergua me sukses`,
            buttons: {
              cancel: 'Mbyll',
            },
          })
    }).then( window.location = `/auth/profile/${user._id}` )

  };


  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate());
    console.log({ result });
    return result;
  }

  const handleChange = (e) => {
    setTime(e.target.value);
    console.log({ time: e.target.value });
  };

  return (
    <>
    <div className="main-termin container">

      <Alert style={{textAlign:'center'}} severity="info">Mbush të dhënat e nevojshme për te rezervuar terminin tuaj!</Alert>

        <label>Selekto daten*</label>
        <br/>
      <DatePicker
      style={{width:'65%', height:'60px'}}
        selected={selectedDate}
        onChange={(date) => setSelectedDate(date.toDate())}
        minDate={new Date()}
        maxDate={addDays(selectedDate, 0)}
        showYearDropdown
        dateFormat="MMMM d, yyyy"
        scrollableYearDropdown
        />

{selectedDate && time &&
      <h1 className="date-time">
        Data e terminit : {moment(selectedDate).format('DD/MM/yyyy')  } / Ora : { time }
      </h1>
}


<div className="time-picker" style={{width:'65%', height:'60px'}}>
<select value={time} onChange={handleChanges} className='form-control' disabled={!selectedDate}>
  {hours.map(hour =>
    minutes.map(minute => (
      <option
      key={`${hour}:${minute}`}
      value={`${hour}:${minute < 10 ? "0" + minute : minute}`}
      // disabled={!occupiedHours.includes(hour)} 
      >
        {hour}:
        {minute < 10 ? "0" + minute : minute}
      </option>
    )))}
</select>


  </div>


      <button 
        onClick={handleReservation}
        className="btn btn-warning"
        disabled={!selectedDate || !time}
       >
        Rezervo
      </button>
    </div>
        </>
  );
};

export default TerminAcc;
